import React from 'react';

interface HelperCardProps {
  title: string;
  image_url: string; // Icon image URL
  onClick?: () => void; // Optional onClick handler
  'data-testid'?: string;
}

export const HelperCard: React.FC<HelperCardProps> = ({
  title,
  image_url,
  onClick,
  'data-testid': testId,
}) => {
  return (
    <div
      data-testid={testId}
      className="w-28 h-28 rounded-lg bg-white flex flex-col items-center justify-between p-2 text-center transition-transform duration-300 ease-in-out"
      onClick={onClick}
      role="button"
      tabIndex={0}
    >
      {/* Icon Section */}
      <div className="w-10 h-10 flex items-center justify-center">
        {/* the image_url in or condition is temporary for now */}
        <img
          src={
            image_url ||
            'https://res.cloudinary.com/dsf1qebes/image/upload/v1732908525/image_400_plfecm.png'
          }
          alt={title}
          className="w-full h-full object-contain"
        />
      </div>

      {/* Title Section */}
      <p className="typography-caption1 text-secondary leading-snug line-clamp-2">
        <abbr className="no-underline" title={title}>
          {title}
        </abbr>
      </p>
    </div>
  );
};
